/**
 * Lab sevenone-1/Bookmaker-UI config → Vite env.
 *
 * Lab injects these into the SPA (see app.js / frontend.ejs):
 *   adminurl         ← process.env.bookmaker_api  / realHost
 *   configurl        ← process.env.config_url     / configHost
 *   commonSocketUrl  ← process.env.common_socket_url / commonSocketHost
 */

function env(name: string, fallback = ''): string {
  const raw = import.meta.env[name]
  return typeof raw === 'string' ? raw.trim() : fallback
}

/** Lab `adminurl` — API root with trailing slash stripped. */
export function getLabAdminUrl(): string {
  const fromExplicit = env('VITE_BOOKMAKER_BASE_URL') || env('VITE_ADMIN_URL')
  if (fromExplicit) return fromExplicit.replace(/\/$/, '')
  // Nest Bookmaker-API root (…/User/userLogin — no /api or /api/bookmaker)
  return 'http://127.0.0.1:3090'
}

/** Lab `configurl` (optional — Kings config service). */
export function getLabConfigUrl(): string {
  return env('VITE_CONFIG_URL').replace(/\/$/, '')
}

/** Same-origin Socket-API SSE base (`/api/socket-api`). Not Socket.IO. */
export function getLabCommonSocketUrl(): string {
  return env('VITE_COMMON_SOCKET_URL').replace(/\/$/, '') || '/api/socket-api'
}

export const LAB_ACCESS_TOKEN_KEY = 'bookMakerAccessToken'
export const LAB_USER_ID_KEY = 'userid'
export const LAB_USERNAME_KEY = 'username'
export const LAB_ADMIN_LEVEL_KEY = 'adminLevel'
export const LAB_2FA_KEY = 'is2faEnabled'

export function getLabAdminLevel(): string {
  try {
    return (localStorage.getItem(LAB_ADMIN_LEVEL_KEY) || '').trim()
  } catch {
    return ''
  }
}

export function getLabUsername(): string {
  try {
    return (localStorage.getItem(LAB_USERNAME_KEY) || '').trim()
  } catch {
    return ''
  }
}

export function getLabAccessToken(): string | null {
  try {
    const t = localStorage.getItem(LAB_ACCESS_TOKEN_KEY)
    return t && t.trim() ? t.trim() : null
  } catch {
    return null
  }
}

export function getLabUserId(): string {
  try {
    return (localStorage.getItem(LAB_USER_ID_KEY) || '').trim()
  } catch {
    return ''
  }
}

export function setLabSession(data: {
  accessToken: string
  _id?: string
  username?: string
  level?: string | number
  is2faEnabled?: boolean
}): void {
  localStorage.setItem(LAB_ACCESS_TOKEN_KEY, data.accessToken)
  if (data._id) localStorage.setItem(LAB_USER_ID_KEY, String(data._id))
  if (data.username) localStorage.setItem(LAB_USERNAME_KEY, String(data.username))
  if (data.level != null) localStorage.setItem(LAB_ADMIN_LEVEL_KEY, String(data.level))
  if (data.is2faEnabled != null) localStorage.setItem(LAB_2FA_KEY, String(data.is2faEnabled))
}

export function clearLabSession(): void {
  for (const k of [
    LAB_ACCESS_TOKEN_KEY,
    LAB_USER_ID_KEY,
    LAB_USERNAME_KEY,
    LAB_ADMIN_LEVEL_KEY,
    LAB_2FA_KEY,
  ]) {
    try {
      localStorage.removeItem(k)
    } catch {
      /* ignore */
    }
  }
}
